import { RefreshCw } from "lucide-react"

export function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center p-8">
      <RefreshCw className="h-6 w-6 animate-spin text-primary-500" />
      <span className="ml-2 text-white">Loading tournament management...</span>
    </div>
  )
} 